function uniq(arr: any[]) {
  return arr.reduce((acc: Array<any>, item: any) => {
    if (!acc.includes(item)) {
      acc.push(item);
    }
    return acc;
  }, []);
}

export function intersect(a: any, b: any) {
  const uniqA = uniq(a);
  const uniqB = uniq(b);

  return uniqA.filter((item: any) => uniqB.indexOf(item) >= 0);
}
